import { render, staticRenderFns } from "./RunNumber.vue?vue&type=template&id=b56f5a14&"
import script from "./RunNumber.vue?vue&type=script&lang=js&"
export * from "./RunNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports